import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initGA, trackPageView, trackEvent } from '../utils/analytics'

export const useAnalytics = () => {
  const location = useLocation()

  useEffect(() => {
    initGA()
  }, [])

  useEffect(() => {
    trackPageView(location.pathname)
  }, [location])

  return {
    trackEvent,
    trackPageView: () => trackPageView(location.pathname),
  }
}

export const useTrackEvent = () => {
  return {
    trackEvent,
    trackLogin: () => trackEvent('login', 'user_action', 'user_login'),
    trackRegister: () => trackEvent('register', 'user_action', 'user_register'),
    trackProjectCreate: () => trackEvent('project_create', 'project_action', 'create_project'),
    trackProjectSave: () => trackEvent('project_save', 'project_action', 'save_project'),
    trackProjectOpen: () => trackEvent('project_open', 'project_action', 'open_project'),
    trackFeatureUse: (featureName: string) =>
      trackEvent('feature_use', 'feature_action', featureName),
    trackError: (errorType: string) => trackEvent('error', 'system_action', errorType),
  }
}
